var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"projectList"}},_vm._l((_vm.projectListDatas),function(item,index){return _c('projectListItem',{key:index,attrs:{"projectListItem":item},nativeOn:{"click":function($event){return _vm.inDetails(item.detailsSrc)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }